export default __webpack_public_path__ + "static/media/loader-button.a988506d.svg";